export default "__VITE_ASSET__643da3c9__"